import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_topgain.png",
      alt: "Estratégias Top Gain",
    },
    title: "Opere com os robôs Top Gain",

    // String ou array de strings
    text: [
      "A casa de análise e tv do mercado financeiro com os melhores traders e analistas do mercado inaugura sua mais nova coleção de algoritmos de daytrade automático no brasil",
    ],
    testimonial: {
      text: "Aqui, liberdade e lucratividade andam lado a lado",
      author: {
        name: "Matheus lima, analista cnpi-t head of market research",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Setups automáticos Top Gain",
    heading: "Estratégias de day trade automatizadas ao seu alcance",
    subtitle:
      "Estratégias testadas e validadas com execução rápida e de forma lucrativa, você está a poucos cliques de acessa-los.",
  },

  cta: {
    title: "Vamos iniciar?",
    subtitle: "Acione agora mesmo os robôs Top Gain",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "Top Gain",
    col1: [
      "A top gain foi criada para tornar os ganhos na bolsa de valores uma realidade do brasileiro, independente do seu conhecimento e classe social. ",
      "Após criar dezenas de soluções lucrativas como indicadores gráficos e relatorios de análise, a top gain agora traduz sua vasta experiência no mercado de capitais em estratégias de daytrade com execução automática e facilmente replicáveis. ",
      "Por trás do projeto de automações está matheus lima, analista certificado cnpi-t com mais de 11 anos de experiência em negociação em bolsa de valores e desenvolvedor de metodologias altamente difundidas no mercado brasilero. ",
    ],
    // col2: [
    //   "Nossa missão é ajudar traders de todos os níveis a aproveitar as vantagens da automação no mercado financeiro.",
    // ],
  },

  stats: {
    title: "Sobre a Top Gain",
    subtitle: "Há 5 anos mudando a vida de milhares de pessoas na bolsa de valores ",
    data: [
      {
        value: "+5",
        description: "Anos em atividade",
      },
      {
        value: "+10k",
        description: "Clientes satisdeitos",
      },
      {
        value: "+300",
        description: "Robôs desenvolvidos",
      },
    ],
  },

  features: {
    title: "Por que utilizar os nossos robôs?",
    subtitle: "Veja quais as principais vantagens dos robôs Top Gain.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description: "Teste nossas estratégias e confira a performance em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description: "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte individual",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas de nossos clientes.",
      },
      ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Quero deixar meu agradecimento ao Amazonas por compartilhar tanto conhecimento sobre trade. Antes de conhecer seus ensinamentos, eu não fazia ideia de como operar de forma segura e eficiente. Além disso, o robô que ele desenvolveu foi um divisor de águas para mim, trazendo ótimos resultados e mais consistência nos meus ganhos. Gratidão por tudo que você faz por nós, Amazonas!",
      author: "Victor Salles",
      job: "Motorista",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Minha jornada no mercado financeiro mudou completamente depois que comecei a seguir o Amazonas. Seus ensinamentos são claros, diretos e transformadores. O robô que ele disponibilizou tem sido um grande aliado, gerando excelentes lucros de forma automatizada. Não tenho palavras para agradecer por toda a ajuda e pelas oportunidades que ele proporciona. Sucesso sempre, Amazonas!",
      author: "Carlos Silva",
      job: "Servidor Público",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da nossa extensão",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
